import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { heroNewImg, IncubationTabbing, investorTabbing } from 'src/assets/images';
import cx from "./contactus.module.scss";
import Footer from 'src/components/footer/footer';
import TopNavigation from '../landingPage/topNavigation/TopNavigation';

function ContactUs() {
    const [change, setIsChange] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <div>
                <TopNavigation change={change} />

                <section className={`${cx.forInvestSec}`}>
                    <Container>
                        <Row>
                            <Col md={8}>
                                <div className={`${cx.content_main}`}>
                                    <h2>Contact Us</h2>
                                    <p style={{ marginBottom: '10px' }}>
                                        If you have questions or need help with our website or app, feel free to reach out.
                                    </p>
                                    <p style={{ marginBottom: '20px' }}>
                                        If you&apos;d like to delete your account or personal data, please email us at:
                                    </p>
                                    <p style={{ marginBottom: '18px' }}>
                                        📧 <strong>Email:</strong> hello@htraction.com
                                    </p>
                                    <p>
                                        Please include your registered email address when submitting a request. We will process your request within 7 business days.
                                    </p>
                                </div>
                            </Col>

                        </Row>
                    </Container>
                </section>
                <Footer />
            </div>

        </>
    )
}

export default ContactUs
